import * as React from "react"
import {Badge, Box, LinearProgress, Typography} from "@mui/material";
import {TooltipSeeker} from "@ui-seeker/core";

import {LabelCountry} from "@components";
import {BORDER_COLOR, BORDER_STYLE} from "@constants";
import {isGroupedByCountry} from "@signals"
import {formatPercentage, translateCountryName} from "@ui-seeker/utils";
import usePricingDiscountRoleConfig from "../../@hooks/useRoleConfig";


const styles = {
    container: {
        borderRight: BORDER_STYLE,
        borderRightColor: BORDER_COLOR,
        height: 1,
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1
    },
    linearProgress: {
        ".MuiLinearProgress-barColorPrimary": {
            backgroundColor: 'text.primary'
        }
    }
}

export default function PricingCandlestickLabelBlock({ label, country, totalSkus, color, totalWithoutDiscount, percentageWithoutDiscount, totalProducts }) {
    return <Box sx={styles.container}>
        <Badge badgeContent=" " sx={{ span: { backgroundColor: color, fontSize: 5, height: 10, minWidth: 10 } }}/>

        <Typography variant="caption" sx={{ fontSize: 12, pl: .5 }}>
            { !!country && <LabelCountry
                country={country}
                label={isGroupedByCountry.value ? translateCountryName(label) : label}
            /> }

            { !country && label }
        </Typography>

        <Typography variant="caption" sx={{ fontSize: 11 }}>
            ({totalSkus})
        </Typography>

        <PricingCandlestickLabelBlockTooltip totalWithoutDiscount={totalWithoutDiscount} totalProducts={totalProducts} totalSkus={totalSkus} percentageWithoutDiscount={percentageWithoutDiscount}>
            <Box sx={{ width: .9 }}>
                <LinearProgress
                    variant="determinate"
                    value={percentageWithoutDiscount}
                    sx={styles.linearProgress}
                />
            </Box>
        </PricingCandlestickLabelBlockTooltip>
    </Box>
}

const PricingCandlestickLabelBlockTooltip = ({ totalProducts, totalWithoutDiscount, totalSkus, percentageWithoutDiscount, children }) => {
    const { isRetailerUser } = usePricingDiscountRoleConfig()
    return <TooltipSeeker
        useLight
        title={<Box>
            { !isRetailerUser && <>
                <Box>Total: {totalProducts}</Box>
                <Box>Without Discount: {totalWithoutDiscount}</Box>
            </> }
            { !!isRetailerUser && <>
                <Box>Total: {totalSkus}</Box>
                <Box>below my price: {formatPercentage(percentageWithoutDiscount)}</Box>
            </> }
        </Box>}
        componentsProps={{
            arrow: {
                sx: { left: "-50px !important" }
            }
        }}
    >
        {children}
    </TooltipSeeker>
}
